// extracted by mini-css-extract-plugin
export default {"signup":"SignUp_signup__LiCwK"};